import script from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=6fb90d68&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb90d68"]])

export default __exports__